import React, { useState, useEffect } from 'react'
import './common.css'
import API_URL from '../common/Apiurl';
import { Link,useParams  } from "react-router-dom"
import SuccessMessage from '../common/Message';

function Editcredit(){
    const apiUrl = API_URL;
    const [items, setItems]=useState('');
    const [createjob, setCreatejob]=useState('');
    const [applyjob, setApplyjob]=useState('');
    const [coinConv, setCoinConv]=useState('');
    const getParam = useParams();
    const getusertype = getParam.id;
    const [successMessages, setSuccessMessages] = useState([]);
    // console.log(getParam.id);
    const getValues = async() =>{
        try{
            const postData = {
                usertype: getusertype
            };
            const result = await fetch(`${apiUrl}/admin/viewcredit`,{
                method: 'POST',
                headers: {
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData)
            });
            const data = await result.json();
            await setItems(data.usertype);
            await setCreatejob(data.createJob)
            await setApplyjob(data.applyjob)
            await setCoinConv(data.coins)
            console.log(data.coins);
        }
        catch(error){
            console.log('Error: ', error)
        }
    }
    useEffect(() => {
        getValues();
    },[]);

    const getcreate = (e) => {
        setCreatejob(e.target.value)
        console.log(e.target.value);
    }
    const getapply = (e)=>{
        setApplyjob(e.target.value)
    }
    const getcoin = (e)=>{
        setCoinConv(e.target.value)
    }
    const updatecredit = async(e) => {
        e.preventDefault();
        // const alldata = new FormData(e.target);
        const createJob = createjob;
        const applyJob = applyjob;
        const coinConver = coinConv;
        try{
            const postData={
                usertype:getusertype,
                createJob:createJob,
                applyJob:applyJob,
                coinConv:coinConver,
            }
            const result = await fetch(`${apiUrl}/admin/updatecredit`,{
                method: "POST",
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData) 
            });
            const data = await result.json();
            if((data.status === 200)){
                const newSuccessMessage = data.message;
                setSuccessMessages([...successMessages, newSuccessMessage]);
            }else if((data.status === 400)){
                const newSuccessMessage = data.message;
                setSuccessMessages([...successMessages, newSuccessMessage]);
            }
            if(data.status !== 200){
                throw new Error('Data not found');
            }
            setItems(data.data);
        }
        catch(error){
            console.log('Error: ', error)
        }
    }
    const handleSuccessMessageFadeOut = async () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        getValues();
    }
    return (
            <div className='width90'>
                <div className='row'>
                    <div className='col-sm-6'>
                        <h2 className='pageTitle'>Update Credit for {items}</h2>
                    </div>
                </div>
                {/* excelsheet */}
                
                <div className="form-group cmnwhitebg pt-4 pb-4 paddingLeft30">
                {getusertype !== '4' ?
                    <form className="form-horizontal" method='POST' onSubmit={updatecredit}>
                        <div className="form-group">
                            <label className="control-label col-sm-2 label" htmlFor="createjob">Create Job:</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" name = "createjob" id="createjob" value={createjob}  onChange={(e)=>getcreate(e)}/>
                            </div>
                        </div>
                        <div className="form-group mt-3">
                            <label className="control-label col-sm-2 label" htmlFor="applyjob">Apply Job:</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" name = "applyjob" id="applyjob" value={applyjob}  onChange={(e)=>getapply(e)} />
                            </div>
                        </div>
                        <div className="form-group mt-3">
                            <label className="control-label col-sm-2 label" htmlFor="coinconv">Coin Conversion:</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" name = "coinconv" id="coinconv" value={coinConv}  onChange={(e)=>getcoin(e)}  />
                            </div>
                        </div>
                        <div className="form-group mt-3">
                            <div className="col-sm-offset-2 col-sm-10">
                                <button type="submit" className="btn btn-default submitBtn">Submit</button>
                            </div>
                        </div>
                    </form>:
                    <form className="form-horizontal" method='POST' onSubmit={updatecredit}>
                        <div className="form-group mt-3">
                            <label className="control-label col-sm-2 label" htmlFor="coinconv">Cash Conversion:</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" name = "coinconv" id="coinconv" value={coinConv}  onChange={(e)=>getcoin(e)}  />
                            </div>
                        </div>
                        <div className="form-group mt-3">
                            <div className="col-sm-offset-2 col-sm-10">
                                <button type="submit" className="btn btn-default submitBtn">Submit</button>
                            </div>
                        </div>
                    </form>
                    }
                    {
                        successMessages.map((message, index) => (
                            <SuccessMessage
                                key={index} 
                                message = {message} 
                                onFadeOut={handleSuccessMessageFadeOut}
                            />
                        )
                    )}
                </div>
                {/* excelsheet */}
            </div>
    )
}

export default Editcredit;